import Api from './api.service';

export default {
  getSpecialties: () => Api.get('specialties'),
  getSubspecialties: (id) =>
    Api.get(`subspecialties?filter[specialty_id]=${id}`),
};
